import React, { useRef, useEffect } from 'react';
import subscribeToFocus from '@/lib/accessibility/focus-trap';

function FocusTrap ({ children }) {
  const trapRef = useRef(null);

  useEffect(() => subscribeToFocus(trapRef), [trapRef]);

  return (
    <div ref={trapRef}>
      {children}
    </div>
  );
}

export default FocusTrap;
